import { Activity } from '@activities/interfaces/activity';
import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component({
  name: 'bpc-activity-card',
  components: {},
})
export default class ActivityCard extends Vue {
  @Prop(Object) readonly item: Activity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  public formatPrice(value: string) {
    return ToolsHelper.formatPrice(value);
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get formattedAge() {
    const { min_age, min_month_age, max_age, max_month_age } = this.item;

    if (!min_age && !min_month_age && !max_age && !max_month_age) {
      return this.$t('global.all_ages');
    }

    const yearsString = ` ${this.$t('global.year(s)')}`;
    const monthString = ` ${this.$t('global.month(s)')}`;

    let minimumAge = '';
    if (min_age) {
      minimumAge = `${min_age}`;
    }
    if (min_month_age && !min_age) {
      minimumAge += `${min_month_age}`;
    }

    let maximumAge = '';
    if (max_age) {
      maximumAge = `${max_age}`;
    }
    if (max_month_age && !max_age) {
      maximumAge += `${max_month_age}`;
    }

    if (min_age && min_month_age) {
      minimumAge = `${(min_age + min_month_age / 12).toFixed(1).replace('.', ',')}`;
    }

    if (max_age && max_month_age) {
      maximumAge = `${(max_age + max_month_age / 12).toFixed(1).replace('.', ',')}`;
    }

    let result = '';
    if (minimumAge) result += `${this.$t('global.from')} ${minimumAge}`;
    if (maximumAge) result += ` ${this.$t('global.to')} ${maximumAge}`;

    if (max_age || min_age) {
      result += yearsString;
    } else {
      result += monthString;
    }

    return result.trim();
  }

  get editActivatedAndShown(): boolean {
    const action = this.item?.actions?.edit;
    return action?.show && action?.activated;
  }

  get detailsActivatedAndShown(): boolean {
    const action = this.item?.actions?.details;
    return action?.show && action?.activated;
  }

  get publicDetailsActivatedAndShown(): boolean {
    const action = this.item?.actions?.publicDetails;
    return action?.show && action?.activated;
  }

  get short_description(): string {
    const clamp = '...';
    const length = 80;
    return this.item.short_description.length > length
      ? this.item.short_description.slice(0, length) + clamp
      : this.item.short_description;
  }

  get startDate(): string {
    if (this.item.start_date) {
      return moment(this.item.start_date, 'YYYY-MM-DD')
        .locale(this.lang)
        .format('ddd DD/MM/YYYY');
    }
    return null;
  }

  get endDate(): string {
    if (this.item.end_date) {
      return moment(this.item.end_date, 'YYYY-MM-DD')
        .locale(this.lang)
        .format('ddd DD/MM/YYYY');
    }
    return null;
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.item.activities[this.currentImgField];
  }
}
